import { render, staticRenderFns } from "./Home.data-manager-bundle-wl.vue?vue&type=template&id=d660ec4c&scoped=true&"
import script from "./Home.data-manager-bundle-wl.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-bundle-wl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d660ec4c",
  null
  
)

export default component.exports